import { SubmitLog } from './saveLogAction';
import { saveLogToStorage } from '../utils/logStorageUtils';
import { addLocalLog } from './scanpackScanningSetters';

const THROTTLE_MS = 1000;
export const ORDER_FINISH_LOG_WAIT_MS = 3000;

let submitLogRunning = false;
let queuedSubmitRetry = null;

export const resetSubmitLogThrottle = () => {
  submitLogRunning = false;
  clearTimeout(queuedSubmitRetry);
  queuedSubmitRetry = null;
};

export const throttledSubmitLog = (dispatch) => {
  if (submitLogRunning) return;
  submitLogRunning = true;
  dispatch(SubmitLog('submitLog'));
  setTimeout(() => { submitLogRunning = false; }, THROTTLE_MS);
};

export const saveAndSubmitLog = async (dispatch, logData, skipLocalLog = false) => {
  await saveLogToStorage(logData);
  if (!skipLocalLog) {
    addLocalLog(dispatch, logData);
  }
  throttledSubmitLog(dispatch);
};

export const submitQueuedLogsPromptly = dispatch => {
  if (!submitLogRunning) {
    throttledSubmitLog(dispatch);
    return;
  }
  clearTimeout(queuedSubmitRetry);
  queuedSubmitRetry = setTimeout(() => {
    queuedSubmitRetry = null;
    throttledSubmitLog(dispatch);
  }, THROTTLE_MS);
};

export const saveAndSubmitPlanOpLog = async (dispatch, logData) => {
  await saveLogToStorage(logData);
  submitQueuedLogsPromptly(dispatch);
};

export const submitQueuedLogsBounded = async dispatch => {
  let timer;
  const bound = new Promise(resolve => { timer = setTimeout(resolve, ORDER_FINISH_LOG_WAIT_MS); });
  try {
    await Promise.race([dispatch(SubmitLog('submitLog')), bound]);
  } finally {
    clearTimeout(timer);
  }
};
